import { Lookup } from "@eres/ejari-api/Entity";

export interface SearchParams {
	isFromLand?: boolean;
	searchBy?: Lookup;
	munNo?: string;
	munSubNo?: string;
	landNo?: string;
	landSubNo?: string;
	area?: Lookup;
	landPropertyId?: number;
}

export interface RegisterPropertyRequest {
	ActiveUserID?: number;
	ActiveUserType?: number;
	LandPropertyId?: number;
	PropertyTypeId?: number;
	BuildingPropertyId?: number;
	VillaName?: string;
	BuildingName?: string;
	UnitNumber?: string;
	ActualArea?: string;
	DEWAPremiseNumber?: string;
	DEWACommon?: boolean;
	EjariPropertyUsageId?: number;
	EjariPropertyTypeId?: number;
	EjariPropertySubTypeId?: number;
	OwnersParticipantId?: number;
}

export interface RegisterPropertyResponse extends AddPropertyErrorResponse {
	Identity?: number;
	EjariPropertyId?: number;
	PropertyId?: number;
	PropertyTypeId?: number;
	HoldType?: 1 | 0;
}

export interface AddPropertyResponse<T> {
	Code: string;
	Message: string;
	Response: T;
}

export interface AddPropertyErrorResponse {
	ServiceValidationErrors: AddPropertyError[];
}

export interface AddPropertyError {
	ErrorEnumCode: string;
	ErrorDescEn: string;
	ErrorDescAr: string;
}

export enum ViewTypes {
	ALL = 0,
	BUILDINGS = 1,
	VILLAS = 2,
}
